import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Logo from '../../media/images/logo-app.svg';
import './LoginForm.css';

const LoginForm = () => {
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await loginUser(username, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-shell">
        <section className="login-brand-panel">
          <div className="login-brand-top">
            <img src={Logo} className="login-brand-logo" alt="Alienzaz logo" />
          </div>

          <div className="login-brand-copy">
            <h1>Alienzaz IP Management</h1>
            <p className="login-brand-subtitle">
              Platforma centralizata pentru gestionarea procedurilor IP, clientilor si dosarelor de proprietate intelectuala.
            </p>
          </div>

          <div className="login-brand-highlights">
            <div className="login-highlight-card">
              <span className="login-highlight-dot" />
              <div>
                <strong>Gestionare centralizata</strong>
                <p>Clienti, dosare si proceduri IP intr-un singur loc, accesibile oricand.</p>
              </div>
            </div>
            <div className="login-highlight-card">
              <span className="login-highlight-dot" />
              <div>
                <strong>Urmarire termene</strong>
                <p>Vizualizezi rapid statusul si termenele pentru fiecare dosar activ.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="login-form-panel">
          <div className="login-form-card">
            <p className="login-form-kicker">Autentificare</p>
            <h2>Bine ai revenit</h2>
            <p className="login-subtitle">
              Conecteaza-te pentru a continua in aplicatia Alienzaz IPMS.
            </p>

            {error && <p className="login-error">{error}</p>}

            <form onSubmit={handleSubmit} className="login-form-fields">
              <div className="login-field">
                <label htmlFor="login-username">Username</label>
                <input
                  id="login-username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Introdu username-ul"
                  autoComplete="username"
                  required
                />
              </div>

              <div className="login-field">
                <label htmlFor="login-password">Parola</label>
                <input
                  id="login-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Introdu parola"
                  autoComplete="current-password"
                  required
                />
              </div>

              <button className="login-submit" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Se conecteaza...' : 'Intra in platforma'}
              </button>
            </form>

            <p className="login-footer-note">
              Accesul este disponibil doar pentru utilizatorii autorizati.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LoginForm;
